module.exports = __webpack_public_path__ + "static/media/money.44030cf3.png";